// challenge-wait.ts — Logique PURE du décompte d'attente du Challenger IA.
//
// L'analyse est synchrone et peut durer plusieurs minutes. Sans repère, cette
// attente est indistinguable d'un écran mort : c'est ce qui a motivé la jauge
// (demande Christophe, 2026-08-27). Finir alors qu'il reste une minute est
// rassurant ; attendre sans savoir combien de temps ne l'est jamais.
//
// Deux règles, et ce sont celles qu'une régression casserait sans qu'aucun test
// d'écran ne s'en aperçoive :
//
// 1. **Le décompte ne descend jamais sous zéro.** Le plafond serveur tranche à
//    peu près à ce moment-là ; afficher « -0:12 » ferait douter de tout le
//    reste.
// 2. **La jauge se vide, elle ne se remplit pas.** Elle représente le temps qui
//    RESTE, ce qui est la question que se pose celui qui attend.

/** Le temps restant, borné à zéro. */
export function remaining(total: number, elapsed: number): number {
  if (!(total > 0)) return 0;
  return Math.max(0, Math.min(total, Math.round(total - elapsed)));
}

/** La part de jauge encore pleine, en pourcentage. */
export function gaugePercent(total: number, left: number): number {
  if (!(total > 0)) return 0;
  return Math.max(0, Math.min(100, (left / total) * 100));
}

/** `m:ss` — la forme sous laquelle on lit une durée d'attente. */
export function mmss(seconds: number): string {
  const safe = Math.max(0, Math.round(seconds));
  const minutes = Math.floor(safe / 60);
  const rest = safe % 60;
  return `${minutes}:${String(rest).padStart(2, '0')}`;
}

// En deçà, la fin du plafond est proche : la jauge le dit par sa couleur, sans
// changer le texte — un message qui s'alarme à l'approche de la limite ferait
// craindre une perte alors que l'analyse aboutit encore souvent à ce stade.
export const NEAR_LIMIT_SECONDS = 30;

/** La couleur de la jauge : accent, puis avertissement près de la limite. */
export function gaugeTone(left: number): string {
  return left <= NEAR_LIMIT_SECONDS ? 'var(--warn)' : 'var(--accent)';
}
